import { useMemo } from 'react'
import OfferInclusionItem from 'components/Common/Inclusions/OfferInclusionItem'
import { formatReturnFlightsGuestLabel } from 'lib/offer/occupancyUtils'
import { useOfferPageFlightPrice } from 'hooks/useFlightPrice'
import { useIntl } from 'react-intl'

interface Props {
  rooms: Array<App.Occupants>
  size?: 'small' | 'medium' | 'large'
  isHighlighted?: boolean
}

function FlashHotelReturnFlightsInclusion(props: Props) {
  const {
    rooms,
    size = 'medium',
    isHighlighted = true,
  } = props
  const intl = useIntl()
  const { oneWayBundle } = useOfferPageFlightPrice()

  const inclusion = useMemo<App.PackageInclusion>(() => ({
    id: 'return-flights-inclusion',
    description: intl.formatMessage(
      oneWayBundle ? {
        id: 'F1g7FBd0J1WCnzHuBpth',
        defaultMessage: 'One-way charter flight included; additional flights selected at checkout',
        description: 'Hotel inclusion for a bundle with only one charter flight direction',
      } : {
        id: 'mXDPkuZjxmPWqEv75K09',
        defaultMessage: 'Return flights for {guestCountLabel}',
        description: 'Inclusion shown on a hotel rate tile when flights are toggled on',
      },
      { guestCountLabel: formatReturnFlightsGuestLabel(rooms) },
    ),
    symbol: oneWayBundle ? 'plane_with_arrow' : 'plane_with_arrows',
  }), [intl, oneWayBundle, rooms])

  return <OfferInclusionItem inclusion={inclusion} isHighlighted={isHighlighted} size={size} />
}

export default FlashHotelReturnFlightsInclusion
